import React, { useEffect, useState } from "react";

const NewArrival = () => {
  const [sarees, setSarees] = useState([]);

  useEffect(() => {
    fetch("https://prsilks.com/proxy.php")
      .then((res) => {
        if (!res.ok) throw new Error("Network error");
        return res.json();
      })
      .then((data) => {
        const filtered = data.filter(
          (item) =>
            item.section && item.section.toLowerCase() === "new arrival"
        );
        setSarees(filtered);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        setSarees([]);
      });
  }, []);

  return (
    <div className="py-6">
      <h2 className="font-abhaya text-lg md:text-2xl 2xl:text-2xl 4xl:text-4xl 8xl:text-5xl 9xl:text-6xl 10xl:text-7xl 11xl:text-8xl text-center font-bold text-secondary tracking-[4px] 3xl:tracking-[7px] 8xl:tracking-[9px] mb-4">
        New Arrival
      </h2>

      <div className="grid grid-cols-2 2xl:grid-cols-4 gap-4 px-4 lg:px-10 3xl:px-12  3xl:gap-7 7xl:px-24  justify-center">
        {sarees.map((item, index) => (
          <div key={index} className="relative flex flex-col items-center">
            {/* Image with button overlay */}
            <div className="relative w-full  bg-gradient-to-b from-white/0 to-black/40 rounded-3xl ">
              <img
                src={item.url}
                alt={item.name || "saree"}
                className="w-full rounded-xl 8xl:rounded-3xl object-cover  "
                 loading="lazy"
              />
              
             <button className=" absolute w-20 py-1 3xl:py-2 8xl:py-2 sm:w-24 md:w-28 8xl:w-40 9xl:w-44 10xl:w-60 11xl:w-[400px] bg-[#000] bg-opacity-55 bg-[linear-gradient(189.61deg,_rgba(255,255,255,0)_-15.76%,_rgba(0,0,0,0)_40.33%)] bottom-4 9xl:bottom-7 11xl:bottom-9 left-1/2 transform -translate-x-1/2  font-semibold  text-[#f4a420] border-2 border-[#f4a420] rounded-lg 3xs:px-[3px] text-[9px]  2xs:text-[12px] xs:px-[4px]  xs:text-[13px]  md:px-3 sm:text-[17px] xl:px-3 xl:text-[18px] 2xl:px-[7px]  2xl:text-[16px] 3xl:text-[13px]  4xl:py-[2px] 4xl:text-[15px] 4xl:border-[3px] 5xl:text-[17px] 7xl:px-3 7xl:text-[19px] 8xl:px-4 8xl:text-[25px] 9xl:px-5 9xl:text-[30px] 10xl:border-[7px] 10xl:px-8 10xl:text-[38px] 11xl:px-10 11xl:text-[57px]  transition-all duration-200">
  <a
    href="https://api.whatsapp.com/send?phone=919363799534&text=I%20am%20interested%20in%20the%20New%20Arrival%20Collection."
    target="_blank"
    rel="noopener noreferrer"
    className="block w-full h-full  font-Belanosima "
  >
    Buy Now
  </a>
</button>



            </div>

            {/* Name below image */}
            <p className="text-center mt-4 font-bellefair text-[12px] xs:text-[16px] md:text-[23px] 3xl:text-xl 7xl:text-2xl 9xl:text-3xl 10xl:text-5xl 11xl:text-7xl  ">
              {item.name}
            </p>
            <div className="justify-start text-black  font-normal font-sans capitalize">{item.price}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewArrival;
